// src/app/rootReducer.js
import { combineReducers } from '@reduxjs/toolkit'
import authSlice from '../redux/slices/authSlice.js'
import themeSlice from '../redux/slices/themeSlice.js'
import uiSlice from '../redux/slices/uiSlice.js'
import globalComponentsSlice from '../redux/slices/globalComponentsSlice.js'
import cmsSlice from '../redux/slices/cmsSlice.js'
import servicesSlice from '../redux/slices/servicesSlice.js'
import industriesSlice from '../redux/slices/industriesSlice.js'
import webinarsSlice from '../redux/slices/webinarsSlice.js'
import blogsSlice from '../redux/slices/blogsSlice.js'
import caseStudiesSlice from '../redux/slices/caseStudiesSlice.js'
import testimonialsSlice from '../redux/slices/testimonialsSlice.js'
import jobsSlice from '../redux/slices/jobsSlice.js'
import modalSlice from '../redux/slices/modalSlice.js'
import formReducer from '../redux/slices/formSlice.js'
import submissionsSlice from '../redux/slices/submissionsSlice.js'

const rootReducer = combineReducers({
    auth: authSlice,
    theme: themeSlice,
    ui: uiSlice,
    global: globalComponentsSlice,
    cms: cmsSlice,
    services: servicesSlice,
    industries: industriesSlice,
    webinars: webinarsSlice,
    blogs: blogsSlice,
    caseStudies: caseStudiesSlice,
    modal: modalSlice,
    form: formReducer,
    testimonials: testimonialsSlice,
    jobs: jobsSlice,
    submissions: submissionsSlice,
})

export default rootReducer